export const getCanExportPermission = state => state.ui.canExport;
export const canFindDuplicates = state => state.ui.canFindDuplicates;
